import { Card, Datepicker, Search, SofturaTable, ModalPopup, Tooltip, ReactSelectBox, EventHandler } from "client/CommonComponents";
import moment from "moment";
import excel from '../../../assets/images/Excel.svg'
import completedIcon from '../../../assets/images/MyOrders/Myorder_Approved.svg'
import cancelledIcon from '../../../assets/images/MyOrders/Cancelled.svg'
import createNewAssessment from '../../../assets/images/Create New Assessment.svg'
import { useEffect, useRef } from "react";
import './Question.scss';
import ViewAssessment from "./ViewAssessment/index";
import { commonExportExcel, handleClearDateFilter, handleDateFilter } from "utils";
import permissions, { ACCESS_DENIED, isAuthorized } from "client/utils/Permissions";
import { CONSTANTS } from "client/utils/constants";


const CustomFilterCell = (props: any) => {
  const { column, search, options, selectQuestions={},  selectUpdatedBy= {}, selectStatus={} } = props;
  const optionsExt = options;
  const myOrderHandleChange = (event: any) => {
    if (event.label !== "Select") {       
      if (column.key === "numberOfQuestion") {
        selectQuestions.current = event.label;
        search(String(event.label).split("-").join(" - "));
      } 
      else if (column.key === "updatedBy") {
        selectUpdatedBy.current = event.label;
        search(event.label);
      }
      else if (column.key === "isActive") {
          selectStatus.current = event.label;
          search(event.label === 'Active');
      } 
    } else {
      if (column.key === "numberOfQuestion") {
          selectQuestions.current = event.label;
      }
      else if (column.key === "updatedBy") {
          selectUpdatedBy.current = event.label;
      }
      else if (column.key === "isActive") {
          selectStatus.current = event.label;
      }
      search();
    }
  };
  
  const getValue = () => {
    if (column.key === "numberOfQuestion") {
      return selectQuestions;
    } 
    else if (column.key === "updatedBy") {
      return selectUpdatedBy;
    }
    else if (column.key === "isActive") {
      return selectStatus;
    } 
  }

  const getDropDownValue = () => {
    let optionArr: any = []
    if (optionsExt) {
      optionsExt?.map((item: any) => (
        optionArr.push({ key: item, value: item, label: item })
      ))
    } else {
      optionArr = [{ label: CONSTANTS.SELECT, text: CONSTANTS.SELECT }]
    }
    return (optionArr)
  }

  return (
    <div className="date-filter-wrapper">
      <Tooltip content={getValue()?.current} data-attribute="Question_Default_Tooltip">
            <ReactSelectBox
              placeholder={CONSTANTS.SELECT}
              name={column?.key}
              onChange={myOrderHandleChange}
              className="form-control"
              value={getValue()?.current ? { label: getValue()?.current , text: getValue()?.current  } : { label: CONSTANTS.SELECT, text: CONSTANTS.SELECT } }
              options={getDropDownValue()}
              isSearchable={true}
             data-attribute="Question_Default_SearchSelectBox" />
          </Tooltip>
      <i
        className="fa fa-times-circle-o"
        aria-hidden="true"
        onClick={() => props?.handleOrderClearSelectFilter(search, getValue(), column)}
      ></i>
    </div>
  );
};

const UpdateDateFilterCell = (props: any) => {
  const { search, UpdatedDate } = props;
  return (
    <div className="date-filter-wrapper">
      <Datepicker
        placeholder="Select"
        value={UpdatedDate.current}
        onChangeDate={(date: any) =>
          handleDateFilter(date, search, UpdatedDate)
        }
       data-attribute="Question_Default_Datepicker" />
      <i
        className="fa fa-times-circle-o"
        aria-hidden="true"
        onClick={() => handleClearDateFilter(search, UpdatedDate)}
      ></i>
    </div>
  );
};

const Question = (props:any) =>{
  const { allAssessments, showAssessment, hidePopup, assessmentData, onSearchOrder } = props

    const UpdatedDate = useRef(null);
    const Questions = useRef<any>(null);
    const UpdatedBy = useRef<any>(null);
    const Status = useRef<any>(null);
    const selectQuestions = useRef("");  
    const selectUpdatedBy = useRef("");
    const selectStatus = useRef("");

    useEffect(()=>{
      if(allAssessments?.length){
        Status.current = [...new Set([...allAssessments.map((item: any) => item.isActive ? 'Active' : 'Deactive').sort()])]
        Questions.current = [...new Set([...allAssessments.map((item: any) => item.numberOfQuestion).sort((a: any, b: any) => a - b)])]
        UpdatedBy.current = [...new Set([...allAssessments.map((item: any) => item.updatedBy?.toLowerCase()).sort()])]
      }
    }, [JSON.stringify(allAssessments)])

    const handleOrderClearSelectFilter = (search: any, value: any, column: any) => {
      search(undefined);
      value.current = "";
    };
  
    const questionColumn = [
        {
            key: "Action",
            title: "Action",
            width: 60,
            Cell: (row:any)=>props?.CustomCell(row?.rowData),
            style: {textAlign: 'center'},
            id:'action-column'
        },
        {
            key: "assessmentTitle",
            title: "Assessment Title",
            width: 120,
        },
        {
            key: "numberOfQuestion",
            title: "# of Questions",
            width: 120,
            FilterCell: (props: any) => (
                <CustomFilterCell
                  {...props}
                  dataItem={allAssessments}
                  options={Questions.current}
                  selectQuestions={selectQuestions}
                  handleOrderClearSelectFilter={handleOrderClearSelectFilter}
                />
            ),
        },
        {
            key: "updatedDate",
            title: "Updated Date",
            width: 120,
            Cell: (row: any) => {
              return (
                <p className="dateSubmitted">
                  {row.rowData.updatedDate
                    ? moment(row.rowData.updatedDate).format("MM/DD/YYYY")
                    : ""}
                </p>
              );
            },
            FilterCell: (updatedDateProps: any) => {
                return <UpdateDateFilterCell 
                {...updatedDateProps} 
                dataItem={allAssessments} 
                UpdatedDate={UpdatedDate}
                />;
            },
        },
        {
            key: "updatedBy",
            title: "Updated By",
            width: 120,
            FilterCell: (props: any) => (
                <CustomFilterCell
                  {...props}
                  dataItem={allAssessments}
                  options={UpdatedBy.current}
                  selectUpdatedBy={selectUpdatedBy}
                  handleOrderClearSelectFilter={handleOrderClearSelectFilter}
                />
            ),
        },
        {
            key: "isActive",
            title: "Status",
            width: 100,
            Cell: (row: any) => <p><img src={`${row.rowData.isActive ? completedIcon : cancelledIcon}`} alt='Status Icon' title={row.rowData.isActive ? 'Active' : 'Deactive'} className="me-1"/>{row.rowData.isActive ? 'Active' : 'Deactive'}</p>,
            FilterCell: (props: any) => (
                <CustomFilterCell
                  {...props}
                  dataItem={allAssessments}
                  options={Status.current}
                  selectStatus={selectStatus}
                  handleOrderClearSelectFilter={handleOrderClearSelectFilter}
                />
            ),
        },
    ]

    const onExportExcel = (_e: any) => {
      if (allAssessments) {
        let dataTable: any[] = [];
        let columnHeaders: any[] = [];
        allAssessments.forEach((item: any) => {
          let excelData: any = {};
          questionColumn.forEach((colDef: any) => {
            if (colDef?.title != 'Action') {
              const colName = colDef?.title;
              const key = colDef?.key;
              let colValue = ''
              if (key == 'updatedDate') {
                const formatDate = moment(item[key]).format('MM/DD/YYYY')
                colValue = formatDate ?? '';
              } else if(key == 'isActive'){
                const status = item[key] ? 'Active' : 'Deactive'
                colValue = status ?? '';
              } else {
                colValue = item[key] ?? '';
              }
              excelData[colName] = colValue;
              if (columnHeaders.length != Object.keys(allAssessments).length) {
                columnHeaders.push(colName);
              }
            }
          });
          dataTable.push(excelData);
        });
        commonExportExcel(dataTable, columnHeaders, 'Assessments', 'Assessments.xlsx')
      }
    }


    return(
      <>
        <div className='assessment-question CustomerMyOrder mt-1'>
             <div className='breadcrumb-toolbar'>
            <button
              className='create-new-order-btn me-2'
              title={isAuthorized(permissions.RequisitionsCreateUpdate) ? 'Create New Assessment' : ACCESS_DENIED}
              disabled={!(isAuthorized(permissions?.CreateAssessment) || isAuthorized(permissions?.ViewAssessment))}
              onClick={props.CreateNewAssessmentClick} data-attribute="Question_Default_Button">
              <img src={createNewAssessment}
                alt='btn-icon' />
              <span>Create New Assessment</span>
            </button>
            </div>
            <Card data-attribute="Question_Default_Card">
                <div className='create-new-order-container'>
                    <div className='grid-block pt-2'>
                        <div className='mb-1 top-section'>
                            <p className='assesst-question-head'>ASSESSMENT QUESTIONS</p>
                            <div className='clearfix mt-sm-2'>
                                <div className='pull-left searchblock'>
                                    <Search 
                                      placeholder='Search By Assessment Title, Status' 
                                      className='searchTextbox' 
                                      onSearch={(e?: any) => onSearchOrder(e, true)} 
                                      onBlur={(e?: any) => onSearchOrder(e, false)} 
                                      onChange={(e?: any) => onSearchOrder(e, false)} 
                                      value={props.myOrdersearchBoxValue}
                                     data-attribute="Question_Default_Searchbox" />
                                </div>
                                <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-0'>
                                    <div className={`excel-section pointer ${isAuthorized(permissions.CreateAssessment) ? "" : 'disable-export-excel'}`}>
                                            <EventHandler onEvent={onExportExcel} data-attribute="Question_Default_EventHandler">
                                                <img src={excel} alt='excel' />
                                            </EventHandler>                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${allAssessments?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                            <SofturaTable
                                data={allAssessments ?? []}
                                columns={questionColumn}
                                sort={true}
                                defaultPageSize={10}
                                pageSizes={[10, 20, 50]}
                                globalSearch={false}
                                filter={true}
                             data-attribute="Question_Default_Grid" />
                        </div>                      
                    </div>
                </div>
            </Card>
        </div>

        {showAssessment && (
          <ModalPopup
            closeModalPopup={hidePopup}
            ModalPopupTitle='VIEW'
            ModalPopupType='large'
            ShowModalPopupFooter={true}
            FooterSecondaryBtnTxt='Cancel'
            ModalPopupName='View Assessment Pop up'
            SecondryBtnOnclick={hidePopup}
           data-attribute="Question_Default_ModalPopup">
            <ViewAssessment data={assessmentData} />
          </ModalPopup>
        )}
    </>
    )
}

export default Question;